/** Trade ticket states in the words an operator uses, shared by every credit page that names a ticket. */
const TICKET_WORDS: Record<string, string> = {
  DRAFT: 'Draft',
  PRECLEAR_PENDING: 'In pre-clearance',
  PRECLEAR_APPROVED: 'Cleared',
  PRECLEAR_REJECTED: 'Pre-clearance refused',
  READY: 'Ready to execute',
  SENT: 'Sent',
  EXECUTED: 'Executed',
  POSTED: 'Posted to IBOR',
  SETTLED: 'Settled',
  CANCELLED: 'Cancelled',
  VOIDED: 'Voided',
  REVERSED: 'Reversed',
};

export const ticketWord = (status: string | null | undefined): string => {
  const key = String(status || '').toUpperCase();
  return TICKET_WORDS[key] || (key ? key.replace(/_/g, ' ').toLowerCase() : 'Unknown');
};

/** The ticket has reached the book of record. */
export const ticketPosted = (status: string | null | undefined): boolean =>
  ['POSTED', 'SETTLED'].includes(String(status || '').toUpperCase());

/** The ticket was withdrawn and will never post. */
export const ticketDead = (status: string | null | undefined): boolean =>
  ['CANCELLED', 'VOIDED', 'REVERSED'].includes(String(status || '').toUpperCase());

/** What the operator does with a ticket in this state, in one sentence. */
export const ticketNextStep = (status: string | null | undefined, hasPortfolio: boolean): string => {
  switch (String(status || '').toUpperCase()) {
    case 'DRAFT': return hasPortfolio ? 'Submit it for pre-clearance.' : 'Choose the portfolio and submit it for pre-clearance.';
    case 'PRECLEAR_PENDING': return 'Compliance is checking it. An override, if one is needed, is requested from the ticket.';
    case 'PRECLEAR_REJECTED': return 'Compliance refused it. Open the ticket to see the rule and request an override or amend it.';
    case 'PRECLEAR_APPROVED':
    case 'READY': return 'It is cleared. Execute and post it.';
    case 'SENT': return 'It is with the counterparty. Record the execution, then post it.';
    case 'EXECUTED': return 'It is executed. Post it to the book of record.';
    default: return 'Open the ticket to continue.';
  }
};
